import React from 'react';

export const HcLogo = ({ size = 'md' }) => (
  <img
    src="/helpconnect/logo.webp"
    alt="HELPConnect"
    className={`select-none w-auto ${size === 'lg' ? 'h-20 sm:h-24' : 'h-10 sm:h-12'}`}
    data-testid="hc-logo"
  />
);
